/**
 * The legal vault's paths. Served on founder.oprappo.com only.
 *
 * Read eagerly by `apps/web/src/business-os.ts`, which is why this file holds nothing but
 * strings and one `import()`: the router has to know these paths before anyone opens the
 * group, and `routes.tsx` must stay behind the `import()` so the group stays off the
 * customer's first load. A path mounted in `routes.tsx` and not listed here — or listed
 * here and no longer mounted — fails `apps/web/src/__tests__/app-shell.test.ts`.
 */
import type { DeferredGroup } from '../../business-os.js';

export const group: DeferredGroup = {
  host: 'founder',
  paths: ['/legal', '/legal/:id'],
  load: () => import('./routes.js').then((m) => m.legalRoutes),
};
